import {useGetBusinessCaseCountQuery, useGetInterestCountQuery} from '@dms/api/sales';

import {Nullish} from 'shared/web';

interface useRecordCountProps {
  customerId: string | Nullish;
  vehicleId: string | Nullish;
}

export function useRecordCount(props: useRecordCountProps) {
  const {data: businessCaseCount} = useGetBusinessCaseCountQuery({
    customerId: props.customerId,
    vehicleId: props.vehicleId,
  });

  const {data: interestCount} = useGetInterestCountQuery({
    customerId: props.customerId,
    vehicleId: props.vehicleId,
  });

  return {
    businessCaseCount,
    interestCount,
  };
}
